<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 652 652"
  >
    <g>
      <path
        d="M137.5,319.5c1.1,0,2.2,0,3.3,0c0.7-1.5,0.7-3.7,0-6.2c-0.7-3.7-1.8-6.2-4-5.9c-2.2,0.4-2.2,3.3-1.5,7
		C135.6,316.6,136.4,318.4,137.5,319.5L137.5,319.5z"
      />
      <g>
        <path
          d="M118.1,322.8c1.5,0.7,2.6,1.1,2.9,0.7c0.4-0.4,0-0.7-0.4-1.5c-0.7-1.5-2.6-2.6-4-3.3c-3.7-1.5-7.7-1.1-11,1.5
			c-1.1,0.7-2.2,1.8-1.8,2.6c0,0.4,0.4,0.4,0.7,0.4c0.7,0,4-1.5,7.7-1.8C114.4,321.3,116.6,322.1,118.1,322.8L118.1,322.8z"
        />
        <path
          d="M114.8,324.6c-2.2,0.4-3.3,1.1-4,1.8s-1.1,1.1-1.1,1.5v0.4h0.4c0.4,0,1.5-0.4,1.5-0.4c2.9-1.1,4.8-1.1,6.6-0.7
			c1.1,0,1.5,0.4,1.8,0c0,0,0-0.4,0-0.7C119.9,325.4,117.7,324.3,114.8,324.6L114.8,324.6z"
        />
      </g>
      <g>
        <path
          d="M115.9,327.2c0.7-1.5,0.7-4.8,0-7.3c-0.7-3.7-1.8-5.9-4.4-5.9c-2.2,0.4-2.2,3.3-1.5,7.3c0.4,2.6,1.5,4,1.8,5.1
			C113.7,329.4,114.8,328.6,115.9,327.2L115.9,327.2z"
        />
      </g>
      <path
        d="M130.9,331.2c1.5,0.7,2.9,0.4,3.7-0.7c0.4-1.1-0.4-2.6-1.8-3.3c-1.5-0.7-2.9-0.4-3.7,0.7
		C128.3,329,129.4,330.5,130.9,331.2z"
      />
      <path
        d="M140,323.2c-1.1,0-2.2,1.1-2.2,2.9c0,1.5,0.7,2.9,2.2,2.9c1.1,0,2.2-1.1,2.2-2.9C141.9,324.6,141.1,323.2,140,323.2z"
      />
      <path
        d="M62.5,351.7c-0.4-0.4-0.7-0.4-1.1,0c-0.4,0-0.7,0-1.1,0c-0.7,0-1.5-0.4-1.8-1.1s-0.4-1.8,0-3.3l0.4-0.7
		c1.1-2.2,2.6-5.5,0.7-8.8c-1.5-2.6-3.3-4-5.9-4.4c-2.6-0.4-5.1,0.7-6.6,2.6c-2.6,2.9-2.9,6.6-2.6,8c0,0.4,0.4,0.7,0.7,0.7
		c0.4,0,1.1-0.4,1.5-1.5v-0.4c0-0.7,0.4-1.5,1.1-2.6c0.7-1.1,1.8-1.8,2.9-1.8c1.1-0.4,2.6,0,3.7,0.7c1.8,1.1,2.6,3.3,1.8,5.5
		c-1.1,1.1-1.5,2.9-1.5,4.8c0.4,3.3,2.6,4.8,4.4,5.1c1.8,0,3.3-1.1,3.3-1.8C62.8,352.1,62.5,352.1,62.5,351.7L62.5,351.7z"
      />
      <path
        d="M168.9,345.5c0-0.4-0.4-1.8-1.1-4l-1.5-3.3c2.6-3.7,2.6-7.3,2.2-9.1c-0.4-2.2-1.5-4.4-3.3-6.6c-1.8-2.2-6.2-4.4-11.7-5.9
		l-2.9-0.7c0,0,0-7-0.4-9.9c0-2.2-0.4-5.5-1.5-8.8c-1.1-4.4-3.3-8.4-6.2-11c7.3-7.7,12.1-16.5,12.1-23.8c0-13.9-17.2-18.3-38.8-9.5
		l-4.4,1.8c0,0-8-8-8.4-8C79.3,225.5,3.6,310,27.7,330.5l5.1,4.4c-1.5,3.7-1.8,7.7-1.5,12.1c0.7,5.5,3.7,11,8,15.4
		c4.4,4,10.2,6.6,16.1,6.6c9.5,22,31.1,35.1,56.3,35.9c27.1,0.7,50.1-12.1,59.6-34.8c0.7-1.5,3.3-8.8,3.3-15.4
		C175.2,348,171.5,345.5,168.9,345.5L168.9,345.5z M57.7,362.7c-0.7,0-1.8,0.4-2.6,0c-8-0.4-17.2-7.7-17.9-16.5
		c-0.7-9.5,4-16.8,12.8-18.7c1.1-0.4,2.2-0.4,3.7-0.4c4.8,0.4,12.1,4,13.9,14.6C69,351.7,66.9,361.2,57.7,362.7z M48.6,321.7
		c-5.5,1.1-10.2,4-13.2,8.4c-1.8-1.5-5.1-4.4-5.5-5.5c-4.8-8.8,5.1-26.3,12.1-35.9c16.8-24.1,43.5-42.4,55.6-39.2
		c2.2,0.7,8.8,8.4,8.8,8.4s-12.4,7-23.8,16.5C67.2,285.8,55.5,303,48.6,321.7z M134.9,359l0.4-0.4c0-0.4-0.4-0.4-0.4-0.4
		s-12.8,1.8-24.9-2.6c1.5-4.4,4.8-2.9,10.2-2.2c9.5,0.7,18.3-0.7,24.5-2.6c5.5-1.5,12.8-4.8,18.3-9.1c1.8,4,2.6,8.8,2.6,8.8
		s1.5-0.4,2.6,0.4c1.1,0.7,1.8,2.2,1.5,5.9c-1.1,7.3-4.4,12.8-9.1,18.3c-2.9,3.3-7,6.2-11.3,8.4c-2.2,1.1-4.8,2.2-7.3,2.9
		c-19.8,6.2-39.5-0.4-45.7-15.4c-0.4-1.1-1.1-2.2-1.1-3.7c-2.6-9.9-0.4-21.6,7-28.9l0,0c0.4-0.4,0.7-1.1,0.7-1.8s-0.4-1.1-0.7-1.5
		c-2.6-3.7-11.3-9.9-9.5-22c1.1-8.8,8.8-14.6,15.7-14.3h1.8c2.9,0,5.9,0.7,8,0.7c4,0,8-0.4,12.4-4c1.5-1.1,2.6-2.2,4.8-2.6
		c0.4,0,0.7-0.4,1.8,0c1.1,0,2.2,0.4,2.9,1.1c3.7,2.6,4,8,4.4,12.4c0,2.6,0.4,8.4,0.4,9.9c0.4,3.7,1.1,4.4,3.3,5.1
		c1.1,0.4,2.2,0.7,3.7,1.1c4.8,1.5,7.7,2.6,9.5,4.4c1.1,1.1,1.5,2.2,1.8,3.3c0.7,4-3.3,9.1-13.2,13.9c-11,5.1-23.8,6.2-32.9,5.1
		l-3.3-0.4c-7.3-1.1-11.3,8.4-7,14.6c2.9,4,10.6,7,17.9,7c17.6,0,31.1-7.3,35.9-13.9l0.4-0.7c0.4-0.4,0-0.7-0.4-0.4
		c-4,2.9-22.3,13.9-41.7,10.6c0,0-2.2-0.4-4.4-1.1c-1.8-0.7-5.1-2.2-5.9-5.9C125,363.8,134.9,359,134.9,359L134.9,359z M110,356.1
		L110,356.1L110,356.1L110,356.1L110,356.1z M80,288.8c5.9-7,13.5-13.2,20.1-16.5c0.4,0,0.4,0,0.4,0.4c-0.4,1.1-1.5,2.9-1.8,4.4
		c0,0.4,0.4,0.4,0.4,0.4c4-2.9,11.3-5.9,17.6-6.2c0.4,0,0.4,0.4,0.4,0.4c-1.1,0.7-1.8,1.8-2.9,2.9c0,0,0,0.4,0.4,0.4
		c4.4,0,10.6,1.5,14.6,4c0.4,0,0,0.7-0.4,0.7c-6.2-1.5-16.1-2.6-26.7,0c-9.5,2.2-16.5,5.9-21.6,9.5C80,289.1,79.7,289.1,80,288.8
		L80,288.8z"
      />
    </g>
    <g>
      <path
        d="M603.6,305.2c-9.1,0-13.2,6.6-15,10.6c-1.1,2.6-1.1,3.3-1.8,3.3c-1.1,0-0.4-2.2,0.4-4.4c1.1-4.8,0.4-8.4,0.4-8.4h-12.8
		v61.5h17.6v-19.4c2.2,3.7,5.9,7.3,11.7,7.3c12.8,0,19-10.6,19-25.2C623,314,615.3,305.2,603.6,305.2L603.6,305.2L603.6,305.2z
		 M598.9,344c-4,0-7-5.1-7-12.1c0-7,2.9-12.1,7-12.1c4.8,0,7,4.4,7,12.1C605.8,340,604,344,598.9,344L598.9,344z"
      />
      <path
        d="M255.7,305.2c-7.7,0-11.3,6.2-13.2,9.9c-1.1,2.2-1.1,4-2.2,4c-1.1,0-0.4-1.5-1.1-4.8c-1.1-4.4-4.8-9.1-12.4-9.1
		c-8,0-11.7,7-13.2,10.6c-1.1,2.6-1.1,3.3-1.8,3.3c-1.1,0-0.4-2.2,0.4-4.4c1.1-4.8,0.4-8.4,0.4-8.4h-12.8v48.3h17.2v-24.1
		c0-4.8,1.8-10.6,5.5-10.6c4,0,4.8,2.9,4.8,8.4v26.3h17.6v-24.1c0-4.4,1.8-10.6,5.5-10.6c4,0,4.8,4.4,4.8,8.4v26h16.8v-28.5
		C271.8,313.3,267.4,305.2,255.7,305.2L255.7,305.2z M552.8,305.2c-7.7,0-11.3,6.2-13.2,9.9c-1.1,2.2-1.1,4-2.2,4
		c-1.1,0-0.4-1.8-1.1-4.8c-1.5-4.4-4.4-9.1-12.4-9.1s-11.7,7-13.2,10.6c-1.1,2.6-1.1,3.3-1.8,3.3c-1.1,0-0.4-2.2,0.4-4.4
		c1.1-4.8,0.4-8.4,0.4-8.4h-12.8v48.3h17.6v-24.1c0-4.8,1.8-10.6,5.5-10.6c4,0,4.8,2.9,4.8,8.4v26.3h17.6v-24.1
		c0-4.4,1.8-10.6,5.5-10.6c4,0,4.8,4.4,4.8,8.4v26h17.2v-28.5C568.9,313.3,564.5,305.2,552.8,305.2L552.8,305.2z M301.8,305.2
		c-13.5,0-23.1,4.8-23.1,4.8v14.6c0,0,10.6-6.2,19.4-6.2c7,0,7.7,3.7,7.3,7c0,0-1.8-0.4-8-0.4c-14.3,0-21.6,6.6-21.6,16.8
		c0,9.9,8,13.9,15,13.9c9.9,0,14.3-6.6,15.7-9.9c1.1-2.2,1.1-3.7,1.8-3.7c1.1,0,0.7,1.1,0.7,3.3c0,3.7,0,6.6,0.7,9.1H323v-23.8
		C322.6,315.8,317.5,305.2,301.8,305.2L301.8,305.2z M297.4,343.3c-4,1.1-6.2-0.4-6.2-2.9c0-3.7,4-5.5,9.5-5.5
		c2.6,0,4.8,0.4,4.8,0.4C305.4,336.7,301.8,342.2,297.4,343.3z M351.5,291.7h17.6v62.9h-17.6C351.5,354.3,351.5,291.7,351.5,291.7z
		 M388.5,330.5c0-4.4,4-8.4,11.3-8.4c8,0,14.6,4,16.1,4.8V310c0,0-5.1-4.8-17.6-4.8c-13.2,0-24.1,7.7-24.1,24.5s9.9,26,24.1,26
		c11,0,17.9-6.2,17.9-6.2v-16.1c-2.2,1.1-8,5.1-16.1,5.1C391.4,338.9,388.5,334.9,388.5,330.5L388.5,330.5z M451.4,305.2
		c-10.2,0-13.9,9.5-14.6,11.3s-1.1,2.6-1.8,2.6c-1.1,0-0.4-2.2,0-3.3c0.7-2.6,2.6-8.8,2.6-16.8c0-5.5-0.7-7.3-0.7-7.3h-15v62.9h17.6
		v-24.1c0-4,1.5-10.6,5.9-10.6c3.7,0,4.8,2.6,4.8,8v26.7h17.6V329C467.1,316.6,465.3,305.2,451.4,305.2L451.4,305.2z M473,306.3
		v48.3h17.6v-48.3c0,0-2.9,1.8-8.8,1.8C475.9,307.8,473,306.3,473,306.3L473,306.3z"
      />
      <ellipse cx="481.8" cy="297.9" rx="10.6" ry="7" />
      <path
        d="M328.5,306.3v48.3H346v-48.3c0,0-2.9,1.8-8.8,1.8C337.2,307.8,328.5,306.3,328.5,306.3z"
      />
      <ellipse cx="337.2" cy="297.9" rx="10.6" ry="7" />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'MailchimpLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
